import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQList({ items, testidPrefix = "faq" }) {
  return (
    <div
      data-testid={`${testidPrefix}-accordion`}
      className="bg-paper rounded-2xl border border-[rgba(74,63,57,0.10)] p-2 sm:p-4"
    >
      <Accordion type="single" collapsible className="w-full">
        {items.map((item, idx) => {
          const slug = `${testidPrefix}-${idx + 1}`;
          return (
            <AccordionItem
              key={slug}
              value={slug}
              className="border-b last:border-b-0 border-[rgba(74,63,57,0.10)]"
            >
              <AccordionTrigger
                data-testid={`${testidPrefix}-trigger-${idx + 1}`}
                className="text-left text-base sm:text-lg font-medium text-ink hover:text-terracotta hover:no-underline py-5 px-3 sm:px-4"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`${testidPrefix}-content-${idx + 1}`}
                className="text-ink-muted leading-[1.75] text-[15px] px-3 sm:px-4 pb-5"
              >
                {item.a}
              </AccordionContent>
            </AccordionItem>
          );
        })}
      </Accordion>
    </div>
  );
}
